import { multimediaIssue, type MultimediaPage } from "./multimedia";
import type { CardTemplatePage } from "../types";

function usableMedia(url: string): boolean {
  try { return ["https:", "blob:"].includes(new URL(url).protocol); }
  catch { return false; }
}

export function pageIssue(page: CardTemplatePage): string | null {
  if (page.type === "image" && page.multimedia) return multimediaIssue(page as MultimediaPage);
  switch (page.type) {
    case "text": return !page.text.trim() ? "Add a message" : !Number.isFinite(page.size) || page.size < 12 || page.size > 500 ? "Choose a text size from 12 to 500" : null;
    case "image": return usableMedia(page.image) ? null : "Upload an image";
    case "drawing": return usableMedia(page.image) ? null : "Add a drawing";
    case "video": return usableMedia(page.video) && usableMedia(page.thumbnail) ? null : "Upload a video";
    case "audio": return usableMedia(page.audio) && Number.isFinite(page.durationInSeconds) && page.durationInSeconds >= 0 && page.durationInSeconds <= 3600 ? null : "Record or upload audio";
    case "giphy": return usableMedia(page.giphyUrl) && usableMedia(page.giphyThumbnail) && page.image === page.giphyUrl && !!page.giphyId.trim() ? null : "Choose a GIF";
  }
}

export function reorderTemplatePages(pages: CardTemplatePage[], sourceUid: string, targetUid: string): CardTemplatePage[] {
  const source = pages.findIndex((page) => page.uid === sourceUid);
  const target = pages.findIndex((page) => page.uid === targetUid);
  if (source < 0 || target < 0 || source === target) return pages;
  const next = [...pages];
  const [moved] = next.splice(source, 1);
  next.splice(target, 0, moved);
  return next;
}
